import React from 'react';

export const passPropsToChildrens = (children: React.ReactNode, props: { [prop: string]: unknown }): React.ReactNode => {
  return React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { ...props });
    }
    return child;
  });
};